import './organisation.css';
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner'
import { Tabs, Tab, Row, Stack, Container } from 'react-bootstrap'
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import * as apiUtility from "../../config/APIUtils";
import BootstrapTable from 'react-bootstrap-table-next';
import { Alert, Paper, Tooltip, Typography } from '@mui/material';
import { RiFileExcel2Line, RiFilePdfLine } from 'react-icons/ri';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import CourseReviewComponent from './../Course_Components/CourseReviewComponent';
import PolicyReviewComponent from '../Policy_Components/PolicyReviewComponent';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Badge } from '@mui/material';
import { BsFiletypePdf } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Sheet } from '@mui/joy';

export default function StaffRoleCourseChecklistComponent(props) {


    const [showSpinner, setshowSpinner] = useState(false);
    var { userId, homeId } = useParams();
    const [userName, setUserName] = useState('');
    const [showArchiveWarning, setArchiveWarningShow] = useState(false);
    const handleCloseArchiveWarning = () => setArchiveWarningShow(false);
    const handleshowArchiveWarning = () => setArchiveWarningShow(true);
    const [courseReviewModal, setCourseReviewModal] = useState(false);
    const [policyReviewModal, setPolicyReviewModal] = useState(false);
    const [checkShowArchiveRole, setCheckShowArchiveRole] = useState(false);
    const [courseReviewData, setCourseReviewData] = useState({});
    const [policyReviewData, setPolicyReviewData] = useState({});


    const [staffRoleDetails, setStaffRoleDetails] = useState([]);

    const [showTemplateDetails, setShowTemplateDetails] = useState(false)

    const [staffFullName, setStaffFullName] = useState('');
    const [archivedObj, setArchivedObj] = useState({});
    const [homeName, setHomeName] = useState("");

    const navigate = useNavigate();
    const { home } = useParams() || {};
    const currentHome = home || '';


    var fullName = '';
    if (props.userId && props.homeId) {
        userId = props.userId;
        homeId = props.homeId;

    }
    //console.log("staffFullName",props.fullName,staffFullName)
    useEffect(() => {
        if (props.fullName) {
            setStaffFullName(props.fullName)
            fullName = props.fullName
        }
        if (!sessionStorage.getItem("homeId") && sessionStorage.getItem("userType") != 'admin') {
            alert("Sorry.Access Not Permitted")
            return (currentHome ? navigate(`/${currentHome}/login`) : navigate(`/login`));

        }
        if (sessionStorage.getItem("allHomeArr") && sessionStorage.getItem("homeId") && sessionStorage.getItem("userType") != 'admin') {
            var flag = false;
            for (var i = 0; i < JSON.parse(sessionStorage.getItem("allHomeArr")).length; i++) {
                if (sessionStorage.getItem("homeId") == JSON.parse(sessionStorage.getItem("allHomeArr"))[i]) {
                    sessionStorage.setItem("homeId", String(homeId))
                    flag = true;
                    break;
                }
            }
            if (!flag) {
                alert("Sorry.Access Not Permitted")
                return (currentHome ? navigate(`/${currentHome}/login`) : navigate(`/login`));
            }
        }
        getStaffRoleData();
        if (homeName == "") {

            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/getHomeByName/" + homeId;
            apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                if (res != 'Something went wrong!' && res != 'No User Found!')
                    setHomeName(res.data)
            }).catch((error) => {
                console.error(error);
                // setshowSpinner(false);
            });
            setHomeName();
        }
        // getCourseListByUser();
    }, [props])

    async function getStaffRoleData() {
        // setshowSpinner(true)
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "orgnization/getUserByName/" + userId;
        apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res != 'Something went wrong!' && res != 'No User Found!')
                setUserName(res.data)
        }).catch((error) => {
            console.error(error);
            // setshowSpinner(false);
        });

        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "orgnization/getStaffCourseRoleCheckList/" + userId + "/" + homeId;
        apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
            if (res.data && res.data.homeCrsRole && res.data.homeCrsRole.length > 0) {
                setStaffRoleDetails(res.data)
            }
            else {
                setStaffRoleDetails([])
            }


            setshowSpinner(false)
            if (staffRoleDetails)
                setshowSpinner(false)
        }).catch((error) => {
            console.error(error);
            setshowSpinner(false);
        });

        if (staffRoleDetails != []) {
            setTimeout(setShowTemplateDetails(true), 500)
        }
    }

    const exportCombinedExcel = async (roleId, roleName, data, id) => {
        try {
            let rowsCount = 6;

            // Title row
            const title = [{ A: 'CarePassport - Policy & Training Requirements Status' }];

            // User info
            let reportView = [{ A: 'Name', B: 'User ID', C: 'Role', D: 'Date' }];
            reportView.push({
                A: staffFullName,
                B: userId,
                C: String(roleName),
                D: (new Date().toLocaleString()).split(',')[0]
            });
            reportView.push("");
            reportView.push("");

            // --- Course Section ---
            let courseHeader = { A: 'Course Code', B: 'Title', C: 'Course Expiry', D: 'Completed' };
            reportView.push(courseHeader);

            for (let i = 0; i < data.course_details.length; i++) {
                rowsCount++;
                reportView.push({
                    A: data.course_details[i].id,
                    B: data.course_details[i].details,
                    C: data.course_details[i].isComp ? (data.course_details[i].crsExp ? data.course_details[i].crsExp.split('T')[0] : 'N/A') : '',
                    D: data.course_details[i].isComp ? 'Y' : 'N',
                });
            }
            reportView.push(""); // spacing
            reportView.push(""); // spacing

            // --- Policy Section ---
            let policyHeader = { A: 'Doc Code', B: 'Title', C: 'Review Status and Expiry', D: 'Completed' };
            reportView.push(policyHeader);

            for (let i = 0; i < data.policy_arr.length; i++) {
                rowsCount++;
                reportView.push({
                    A: data.policy_arr[i].policyId,
                    B: data.policy_arr[i].title,
                    C: data.policy_arr[i].isComp ? (data.policy_arr[i].expiry ? data.policy_arr[i].expiry + data.policy_arr[i].expiryType : 'N/A') : '',
                    D: data.policy_arr[i].isComp ? 'Y' : 'N',
                });
            }




            // Combine everything
            const finalData = [...title, ...reportView];
            const worksheet = XLSX.utils.json_to_sheet(finalData, { skipHeader: true });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "StaffReport");
            const workbookblob = workbook2blob(workbook);

            // Styling
            XlsxPopulate.fromDataAsync(workbookblob).then((workbook) => {
                workbook.sheets().forEach((sheet) => {
                    sheet.column("A").width(25);
                    sheet.column("B").width(80);
                    sheet.column("C").width(30);
                    sheet.column("D").width(20);

                    sheet.range("A1:D1").merged(true).style({
                        bold: true,
                        fontFamily: "Arial",
                        horizontalAlignment: "center",
                        verticalAlignment: "center",
                    });

                    sheet.range("A2:D2").style({
                        fill: "A6A6A6",
                        bold: true,
                        horizontalAlignment: "center",
                    });

                    sheet.range("A3:D3").style({
                        bold: true,
                        horizontalAlignment: "center",
                    });
                });

                return workbook.outputAsync().then((workbookBlob) => {
                    const downloadAnchorNode = document.createElement("a");
                    const dateVar = new Date();
                    const fileName = "Carepassport_StaffCombinedRequirement-" +
                        dateVar.getDate() + dateVar.getMonth() + dateVar.getFullYear() + "_" +
                        dateVar.getHours() + dateVar.getMinutes() + ".xlsx";
                    downloadAnchorNode.setAttribute("href", URL.createObjectURL(workbookBlob));
                    downloadAnchorNode.setAttribute("download", fileName);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                });
            });
        } catch (error) {
            console.log(error);
        }
    };


    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary",
        };
        const wbout = XLSX.write(workbook, wopts);

        // The application/octet-stream MIME type is used for unknown binary files.
        // It preserves the file contents, but requires the receiver to determine file type,
        // for example, from the filename extension.
        const blob = new Blob([s2ab(wbout)], {
            type: "application/octet-stream",
        });
        return blob;
    };

    const s2ab = (s) => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; i++) {
            view[i] = s.charCodeAt(i);
        }
        return buf;
    }







    function setArhiveStatus(role_id, role_name, id, archiveStatus) {
        var tempArchiveObj = {};
        tempArchiveObj.role_id = String(role_id);
        tempArchiveObj.role_name = String(role_name);
        tempArchiveObj.home_id = String(homeId);
        tempArchiveObj.user_id = String(userId);
        tempArchiveObj.staffArchiveStatus = String(archiveStatus);
        tempArchiveObj.staffFullName = String(staffFullName);
        setArchivedObj(tempArchiveObj)

        if (archiveStatus == 'Active') {
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/checkArchiveStatusForStaff/";
            apiRequest.data = { home_id: homeId, user_id: userId, role_id: role_id, id: id };
            apiUtility.updateAPIDataPUT(apiRequest).then(res => {
                if (res.data == 'Archived') {
                    getStaffRoleData();
                    handleshowArchiveWarning();
                }
                else {
                    getStaffRoleData();
                    saveArchiveStatus(tempArchiveObj);
                }

            }).catch((error) => {
                console.error(error);
                alert("Something Went Wrong!")
            });

        }
        else {
            var apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/setArchiveStatus/";
            apiRequest.data = { home_id: homeId, user_id: userId, role_id: role_id, id: id, staffArchiveStatus: archiveStatus, staffFullName: staffFullName, role_name: role_name };
            apiUtility.updateAPIDataPUT(apiRequest).then(res => {
                if (archiveStatus == 'Archive') {
                    getStaffRoleData();
                    alert("Staff Employment status changed!")
                }
                else {
                    getStaffRoleData();
                    alert("Email Sent to User!")

                }
            }).catch((error) => {
                console.error(error);
                alert("Something Went Wrong!")
            });

        }


    }

    function saveArchiveStatus(archivedObj) {
        handleCloseArchiveWarning()
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "orgnization/setArchiveStatus/";
        apiRequest.data = archivedObj;
        apiUtility.updateAPIDataPUT(apiRequest).then(res => {
            if (archivedObj.staffArchiveStatus == 'Archive') {
                alert("Staff Employment status changed!")
            }
            else {
                alert("Email Sent to User!")

            }
        }).catch((error) => {
            console.error(error);
            alert("Something Went Wrong!")
        });

    }
    function handlePolicyHistoryPopup(user_id, home_id, policyId, title, roleName) {
        console.log(staffRoleDetails);
        var apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "policy/getPolicyHistoryForUser/" + userId + "/" + policyId;
        // apiRequest.data = { home_id: homeId, user_id: userId, role_id: role_id, id: id };
        apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {

            let policyData = res.data.result;
            policyData.forEach(item => {
                item.title = title;
            });
            setPolicyReviewData({ "firstName": staffRoleDetails?.firstName, "lastName": staffRoleDetails?.lastName, "dob": staffRoleDetails?.dob, "user_id": staffRoleDetails?.user_id, home_id, roleName, "role_id": staffRoleDetails?.homeCrsRole[0]?.role_id, policyData });

            setPolicyReviewModal(true);
        }).catch((error) => {
            console.error(error);
            alert("Something Went Wrong!")
        });

    }
    function handleCourseHistoryPopup(user_id, home_id, id, title, roleName) {
        console.log(user_id, home_id, id, title);
        // setCourseReviewData({user_id,home_id,id});
        var apiRequest = apiUtility.apiInputRequest;
        // apiRequest.endPoint = "policy/getCourseHistoryForUser/" + userId + "/" + id;
        apiRequest.endPoint = "course/fetchUserCourseRegistrations/";

        apiRequest.data = { userId: parseInt(userId), crsId: id };
        console.log("Api request------->",apiRequest)
                apiUtility.sendAPIDataPOST(apiRequest).then(res => {
            console.log(res.data);
            let courseData = res.data;
            // courseData.forEach(item => {
            //     item.crs_title = title;
            // });

            setCourseReviewData({ "firstName": staffRoleDetails?.firstName, "lastName": staffRoleDetails?.lastName, "dob": staffRoleDetails?.dob, "user_id": staffRoleDetails?.user_id, home_id, roleName, courseData, title});

            setCourseReviewModal(true);

            // setPolicyReviewModal(true);
        }).catch((error) => {
            console.error(error);
            alert("Something Went Wrong!")
        });
    }

    var cols = (roleName) => [{
        dataField: 'id',
        text: 'Course Code',
        sort: true,
        style: {
            fontWeight: 'bold',
            height: '8%'
        },
        formatter: (cell, row) => (
                <Tooltip title="View history" disableRipple>
                    <IconButton
                        onClick={() => { handleCourseHistoryPopup(userId, homeId, row.id, row.details, roleName) }}
                        color="primary" variant="outlined"
                        sx={{ cursor: "pointer", borderRadius: "30px",
                        height: "0.6em",
                        maxHeight: "1.2em",
                        padding: "1px 10px" }}
                    >
                        <Typography variant="body2" noWrap sx={{ flexGrow: 1 }}><OpenInNewOutlinedIcon style={{fontSize:"1pc"}} fontSize="small" />&nbsp;{row.id}</Typography>
                    </IconButton>
                </Tooltip>
                
           
        )
    },
    {
        dataField: 'details',
        text: 'Title',
        sort: true,
        headerStyle: { cursor: 'pointer' },
        formatter: (cell, row) => (
            <Typography variant="subtitle1">{row.details}</Typography>
        )

    },
    {
        dataField: 'crsExp',
        text: 'Completion Status and Expiry',
        sort: true,
        headerStyle: { cursor: 'pointer' },
        formatter: (rowContent, item) => {
            return (
                <span style={{ cursor: "pointer" }} > <input
                    type="checkbox" style={{ transform: "scale(1.5)", marginLeft: "15%" }}
                    defaultChecked={item.isComp} disabled
                /> &nbsp;{item.isComp ? (
                    <span style={{ marginLeft: "8px" }}>
                        {/* {item.crsExp ? new Date(item.crsExp).toLocaleDateString() : 'N/A'} */}
                        {
                            item.crsExp
                                ? (new Date(item.crsExp) > new Date()
                                    ? new Date(item.crsExp).toLocaleDateString()
                                    : 'Expired')
                                : 'N/A'
                        }
                    </span>
                ) : ''} </span>
            )
        },

        sortFunc: (a, b, order, dataField, rowA, rowB) => {
            // Case 3: when rowA.isComp is false
            if (!rowA.isComp && rowB.isComp) {
                return order === 'asc' ? -1 : 1;
            }
            if (rowA.isComp && !rowB.isComp) {
                return order === 'asc' ? 1 : -1;
            }

            // Case 1: when rowA.isComp is true and rowA.crsExp is mentioned.
            if (rowA.isComp && rowA.crsExp) {
                if (!rowB.isComp || (rowB.isComp && !rowB.crsExp)) {
                    return order === 'asc' ? -1 : 1;
                }
                return new Date(rowA.crsExp) - new Date(rowB.crsExp);
            }

            // Case 2: when rowA.isComp is true and rowA.crsExp is missing/empty
            if (rowA.isComp && !rowA.crsExp) {
                if (!rowB.isComp || (rowB.isComp && !rowB.crsExp)) {
                    return order === 'asc' ? 1 : -1;
                }
                return order === 'asc' ? 1 : -1;
            }

            // Default case
            return 0;
        }
    }];
    const colsPolicy = (roleName) => [{
        dataField: 'policyId',
        text: 'Doc Code',
        sort: true,
        style: {
            fontWeight: 'bold',
            height: '5%'
        },
        formatter: (cell, row) => (
            <Tooltip title="View history" disableRipple>
                    <IconButton
                        onClick={() => handlePolicyHistoryPopup(userId, homeId, row.policyId, row.title, roleName)}
                        color="primary" variant="outlined"
                        sx={{ cursor: "pointer", borderRadius: "30px",
                        height: "0.6em",
                        maxHeight: "1.2em",
                        padding: "1px 10px" }}
                    >
                        <Typography variant="body2" noWrap sx={{ flexGrow: 1 }}><OpenInNewOutlinedIcon style={{fontSize:"1pc"}} fontSize="small" />&nbsp;{row.policyId}</Typography>
                    </IconButton>
                </Tooltip>

        )
    },

    {
        dataField: 'title',
        text: 'Title',
        sort: true,
        headerStyle: { cursor: 'pointer' },
        formatter: (cell, row) => (
            <Typography variant="subtitle1">{row.title}</Typography>
        )

    },
    {
        dataField: 'policyExp',
        text: 'Review Status and Expiry',
        sort: true,
        headerStyle: { cursor: 'pointer' },
        formatter: (rowContent, item) => {
            return (
                <span style={{ cursor: "pointer" }} > <input
                    type="checkbox" style={{ transform: "scale(1.5)", marginLeft: "15%" }}
                    defaultChecked={item.isComp} disabled
                /> &nbsp;{item.isComp ? (
                    <span style={{ marginLeft: "8px" }}>
                        {/* {item.crsExp ? new Date(item.crsExp).toLocaleDateString() : 'N/A'} */}
                        {
                            item.policyExp
                                ? (new Date(item.policyExp) > new Date()
                                    ? new Date(item.policyExp).toLocaleDateString()
                                    : 'Expired')
                                : 'N/A'
                        }
                    </span>
                ) : ''} </span>
            )
        },

        sortFunc: (a, b, order, dataField, rowA, rowB) => {
            // Case 3: when rowA.isComp is false
            if (!rowA.isComp && rowB.isComp) {
                return order === 'asc' ? -1 : 1;
            }
            if (rowA.isComp && !rowB.isComp) {
                return order === 'asc' ? 1 : -1;
            }

            // Case 1: when rowA.isComp is true and rowA.crsExp is mentioned.
            if (rowA.isComp && rowA.policyExp) {
                if (!rowB.isComp || (rowB.isComp && !rowB.policyExp)) {
                    return order === 'asc' ? -1 : 1;
                }
                return new Date(rowA.policyExp) - new Date(rowB.policyExp);
            }

            // Case 2: when rowA.isComp is true and rowA.crsExp is missing/empty
            if (rowA.isComp && !rowA.policyExp) {
                if (!rowB.isComp || (rowB.isComp && !rowB.policyExp)) {
                    return order === 'asc' ? 1 : -1;
                }
                return order === 'asc' ? 1 : -1;
            }

            // Default case
            return 0;
        }
    }];



    var exportCombinedAuditPDF = async (roleId, roleName, data, id) => {
        const title1 = 'CarePassport';

        const doc = new jsPDF("portrait", "pt", "A4");
        const pageWidth = doc.internal.pageSize.getWidth();

        doc.setFontSize(15);
        doc.setDrawColor('#cccccc');

        doc.rect(40, 20, pageWidth - 80, 35);

        doc.text(title1, pageWidth / 2, 43, { align: "center" });


        const userBody = [
            { first: 'Name : ' + staffFullName },
            { first: 'UserId : ' + userId },
            { first: 'Home : ' + homeName + "(" + homeId + ")" },
            { first: 'Date : ' + new Date().toLocaleString() },
            { first: 'Role : ' + String(roleName) }
        ];

        autoTable(doc, {
            head: [{ first: 'User Information' }],
            body: userBody,
            styles: { font: 'helvetica', cellWidth: 'wrap' },
            startY: 80,
            theme: 'plain'
        });

        let afterUserInfoY = doc.lastAutoTable.finalY + 20;

        doc.setFontSize(13);
        doc.text("Training Requirements Status", 40, afterUserInfoY);

        let courseHeaders = [['Course Code', 'Title', 'Course Expiry', 'Completed']];
        let courseTableData = data.course_details.map(c => [
            c.id,
            c.details,
            c.isComp ? (c.crsExp ? c.crsExp.split('T')[0] : 'N/A') : '',
            c.isComp ? 'Y' : 'N'
        ]);

        autoTable(doc, {
            startY: afterUserInfoY + 20,
            head: courseHeaders,
            body: courseTableData,
            styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
            headStyles: { fillColor: [0, 102, 153], halign: 'center' },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            theme: 'grid'
        });


        doc.addPage();
        doc.setFontSize(15);
        doc.text(title1, pageWidth / 2, 43, { align: "center" });

        let afterTitleY = 43 + 25; // 25px spacing

        doc.setFontSize(13);
        doc.text("Policy Requirements Status", 40, afterTitleY);


        let policyHeaders = [['Doc Code', 'Title', 'Policy Expiry', 'Completed']];
        let policyTableData = data.policy_arr.map(p => [
            p.policyId,
            p.title,
            p.isComp ? (p.expiry ? p.expiry + p.expiryType : 'N/A') : '',
            p.isComp ? 'Y' : 'N'
        ]);

        autoTable(doc, {
            startY: 90,
            head: policyHeaders,
            body: policyTableData,
            styles: { font: 'helvetica', cellWidth: 'auto', minCellWidth: 2 },
            headStyles: { fillColor: [15, 111, 197], halign: 'center' },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            theme: 'grid'
        });


        doc.setProperties({
            title: title1,
            subject: 'Carepassport auto generated reports',
            author: 'LCPT',
            keywords: 'generated, javascript, web 2.0, ajax',
            creator: 'LCPT'
        });


        doc.save("Carepassport_StaffCombinedRequirement.pdf");
    };

    function submitReassignData() {
        getStaffRoleData();
    }

    function showArchivedRoles(checked) {
        setCheckShowArchiveRole(checked);
        console.log(checked);
    }

    return (
        <Container fluid style={{ padding: "0px", position: "relative" }}>
            {!showTemplateDetails ? (
                <div>No template details to display</div>
            ) : (
                <Box sx={{ width: '100%', minWidth:"900px", typography: 'body1', padding: "20px", position: "relative" }}>
                    <Sheet variant="soft" color='primary' sx={{ p: 1, m: 1, borderRadius: '8px'}}>
                        <Stack direction="row" style={{display:"flex", justifyContent:"space-between"}}>
                            <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}}>{staffFullName ? (<Typography variant='body-sm'>Role based Training Requirements Status : {staffFullName}</Typography>)
                                : <Typography variant='body-sm'>Status of Training Requirements by Role for : {userName}</Typography>}
                            </div>
                            <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                <Typography variant='body-sm'><input style={{ transform: "scale(1.2)" }} type='checkbox' onChange={(e) => { showArchivedRoles(e.target.checked); }}></input>&nbsp;&nbsp;Include De-activated Roles</Typography>
                            </div>
                        </Stack>
                    </Sheet>

                    <Box sx={{ width: '100%', typography: 'body1', padding: "10px", position: "relative" }}>
                    {(staffRoleDetails.length == 0) ? <Alert variant="outlined" severity="error"><Spinner animation="border" size="sm" /> No Active Roles Found!</Alert> :
                        
                            <Tabs id="uncontrolled-tab-example" className="mb-3" fill>
                                {staffRoleDetails.homeCrsRole
                                    .filter(data => {
                                        const status = data.staffArchiveStatus.find(
                                            role => role.role_id === data.role_id
                                        )?.roleStatus;
                                        if (status !== "Archive") return true;
                                        return checkShowArchiveRole === true;
                                    })
                                    .map((data, id) => (

                                        (<Tab eventKey={data.role_id} title={data.role_name} key={id}>
                                            <Sheet variant="outlined" color='neutral' sx={{ p: 2, m: 1, borderRadius: '8px' }}>
                                                <Tabs id="uncontrolled-tab-example" className="mb-3" >
                                                    <Tab
                                                        eventKey="Courses"
                                                        key="Courses1"
                                                        title={
                                                            data.staffArchiveStatus.find((item => item.role_id === data.role_id))?.roleStatus != "Active" ? "Courses" :
                                                                <React.Fragment>
                                                                    <Badge badgeContent={data.pendingCourseCount} color='warning'>
                                                                        Courses
                                                                    </Badge>
                                                                </React.Fragment>
                                                        }
                                                    >
                                                        <Modal show={showArchiveWarning} onHide={handleCloseArchiveWarning}>
                                                            <Modal.Header closeButton>
                                                                <Modal.Title>Warning</Modal.Title>
                                                            </Modal.Header>
                                                            <Modal.Body>
                                                                <h5>Are you sure that you want to activate this staff in this role?  The role template is currently archived and if you activate the staff, the role template status will be changed to active.</h5>
                                                            </Modal.Body>
                                                            <Modal.Footer>
                                                                <Button variant="secondary" onClick={handleCloseArchiveWarning}>
                                                                    Cancel
                                                                </Button>
                                                                <Button variant="primary" onClick={() => saveArchiveStatus(archivedObj)}>
                                                                    Yes
                                                                </Button>
                                                            </Modal.Footer>
                                                        </Modal>
                                                        <Table id={id}>
                                                            {/* <h2>Role Status: {data.emp_status}</h2> */}
                                                            {

                                                                <div>
                                                                    {data.staffArchiveStatus.find(role => role.role_id === data.role_id)?.roleStatus !== "Active" ? (
                                                                        <Box>
                                                                            <br></br>
                                                                            {(data.staffArchiveStatus.find(role => role.role_id === data.role_id)?.roleStatus === "Hold") ? (
                                                                                <Alert variant="outlined" severity="warning">Role is pending for confirmation through email</Alert>
                                                                            ) : (
                                                                                <Alert variant="outlined" severity="warning">Please activate user role to view course completion details</Alert>
                                                                            )}
                                                                            <br></br>
                                                                        </Box>
                                                                    ) :
                                                                        <Box>
                                                                            {data.course_details.length < 1 ? <div></div> :
                                                                                <Typography variant="subtitle1" align="center">Course Completion Status for {data.role_name} : {data.course_status}</Typography>}
                                                                            <BootstrapTable striped hover keyField='courseID' data={data.course_details} columns={cols(data?.role_name)} noDataIndication={ () => <div>No Course Data available for selected Role</div> }/>
                                                                        </Box>
                                                                    }
                                                                </div>}
                                                        </Table>
                                                        <Row>
                                                            <Stack direction="row" display="flex" justifyContent="space-between" spacing={2} sx={{ marginLeft: "1%", width: "100%", gap: "8px" }}>
                                                                {data.staffArchiveStatus.find(role => role.role_id === data.role_id)?.roleStatus == "Active" &&
                                                                    <div style={{ display: "flex", gap: "8px", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                        <Paper component="form" variant="outlined"
                                                                            sx={{ marginBottom: "4px", alignItems: 'center', width: 43, marginRight: "8%" }}
                                                                        >
                                                                            <Tooltip variant="contained" title="Export to Excel" disableRipple>
                                                                                <IconButton color="primary" onClick={(e) => {
                                                                                    { exportCombinedExcel(data.role_id, data.role_name, data, id) }
                                                                                }} sx={{ p: '8px' }} aria-label="directions">
                                                                                    <RiFileExcel2Line />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Paper>
                                                                        <Paper component="form" variant="outlined"
                                                                            sx={{ marginBottom: "4px", alignItems: 'center', width: 43, marginRight: "8%" }}
                                                                        >
                                                                            <Tooltip variant="contained" title="Export to Pdf" disableRipple>
                                                                                <IconButton color="primary" onClick={(e) => {
                                                                                    { exportCombinedAuditPDF(data.role_id, data.role_name, data, id) }
                                                                                }} sx={{ p: '8px' }} aria-label="directions">
                                                                                    <BsFiletypePdf />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Paper>
                                                                    </div> }
                                                                {data.staffArchiveStatus.find((role) => (role.role_id === data.role_id && role.roleStatus != "Archive")) ?
                                                                    <div style={{ float: 'right' }}><Button variant='warning' onClick={(e) => {
                                                                        { setArhiveStatus(data.role_id, data.role_name, id, 'Archive') }
                                                                    }}
                                                                    >Archive Role</Button></div> :
                                                                    <div style={{ float: 'right' }}><Button variant='warning' onClick={(e) => {
                                                                        { setArhiveStatus(data.role_id, data.role_name, id, 'Active') }
                                                                    }}
                                                                    >Activate Role</Button></div>
                                                                }

                                                            </Stack>
                                                        </Row>
                                                    </Tab>
                                                    {/* <Tab as={Col} eventKey="trainingCart" title={
                                                                <React.Fragment>
                                                                    Training Cart &nbsp;
                                                                    <Badge color="primary" badgeContent={cartCourseCount}>
                                                                        <ShoppingCartIcon />
                                                                    </Badge>
                                                                </React.Fragment>
                                                            }>
                                                                <UserTrainingCart userId={props.userId} homeId={props.homeID} count={cartCourseCount} cartCourseList={cartCourseList} handleCourseCartCallback={handleCourseCartCallback} updatedCartAfterSubmission={updatedCartAfterSubmission} />
                                                            </Tab> */}
                                                    <Tab eventKey="Policies" key="Policies1" title={
                                                        data.staffArchiveStatus.find((item => item.role_id === data.role_id))?.roleStatus != "Active" ? "Policies" :
                                                            <React.Fragment>
                                                                <Badge badgeContent={data.pendingPolicyCount} color='warning'>
                                                                    Home Docs
                                                                </Badge>
                                                            </React.Fragment>
                                                    }
                                                    >

                                                        <Table id={id}>
                                                                <div>
                                                                    {data.staffArchiveStatus.find(role => role.role_id === data.role_id)?.roleStatus !== "Active" ? (
                                                                            <Box>
                                                                                <br></br>
                                                                                {(data.staffArchiveStatus.find(role => role.role_id === data.role_id)?.roleStatus == "Hold") ? (
                                                                                    <Alert variant="outlined" severity="warning">Role is pending for confirmation through email</Alert>
                                                                                ) : (
                                                                                    <Alert variant="outlined" severity="warning">Please activate user role to view course completion details</Alert>
                                                                                )}
                                                                                <br></br>
                                                                            </Box>
                                                                        ) :
                                                                            <Box>
                                                                                {staffRoleDetails?.homeCrsRole?.length < 1 ? <div></div> :
                                                                                    <Typography variant="subtitle1" align="center">Home Doc Review Status for {data.role_name} : {data.policy_status}</Typography>}
                                                                                <BootstrapTable striped hover keyField='policyID' data={data?.policy_arr} columns={colsPolicy(data?.role_name)} noDataIndication={ () => <div>No Home Doc Data available for selected Role</div> }/>
                                                                            </Box>
                                                                    }
                                                                </div>
                                                        </Table>
                                                        <Row>
                                                            <Stack direction="row" spacing={2} >
                                                                <div style={{ display: "flex", gap: "8px", justifyContent: "flex-start", alignItems: "flex-start" }}>
                                                                <Paper component="form" variant="outlined"
                                                                    sx={{ marginBottom: "4px", alignItems: 'center', width: 43, marginRight: "8%" }}
                                                                >
                                                                    <Tooltip variant="contained" title="Export to Excel" disableRipple>
                                                                        <IconButton color="primary" onClick={(e) => {
                                                                            { exportCombinedExcel(data.role_id, data.role_name, data, id) }
                                                                        }} sx={{ p: '8px' }} aria-label="directions">
                                                                            <RiFileExcel2Line />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Paper>
                                                                <Paper component="form" variant="outlined"
                                                                    sx={{  marginBottom: "4px", alignItems: 'center', width: 43, marginRight: "8%" }}
                                                                >
                                                                    <Tooltip variant="contained" title="Export to Pdf" disableRipple>
                                                                        <IconButton color="primary" onClick={(e) => {
                                                                            { exportCombinedAuditPDF(data.role_id, data.role_name, data, id) }
                                                                        }} sx={{ p: '8px' }} aria-label="directions">
                                                                            <BsFiletypePdf />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Paper>
                                                                </div>
                                                                {/* </Col>
                                            <Col xs={12} md={2} className="text-center"> */}
                                                                {/* {(data.staffArchiveStatus.find((role) => console.log(role,data) (role.role_id === data.role_id && role.status === "Archive")))} */}
                                                                {data.staffArchiveStatus.find((role) => (role.role_id === data.role_id && role.roleStatus != "Archive")) ?
                                                                    <div>
                                                                        <Button variant='warning' onClick={(e) => {
                                                                        { setArhiveStatus(data.role_id, data.role_name, id, 'Archive') }
                                                                    }}
                                                                    >Archive Role</Button></div> :
                                                                    <div>
                                                                        <Button variant='warning' onClick={(e) => {
                                                                        { setArhiveStatus(data.role_id, data.role_name, id, 'Active') }
                                                                    }}
                                                                    >Activate Role</Button></div>
                                                                }

                                                            </Stack>
                                                        </Row>
                                                    </Tab>
                                                </Tabs>
                                            </Sheet>
                                        </Tab>)

                                    ))
                                }

                            </Tabs>
                        }
                        </Box>
                </Box>
            )
            }
            <CourseReviewComponent open={courseReviewModal} onClose={() => setCourseReviewModal(false)} courseData={courseReviewData} history={courseReviewData} />
            <PolicyReviewComponent open={policyReviewModal} onClose={() => { setPolicyReviewModal(false); submitReassignData() }} policyData={policyReviewData} history={policyReviewData} />
        </Container>);
}

